<template>
  <b-autocomplete
    v-model="keyword"
    async
    icon="magnify"
    :data="data"
    field="label"
    placeholder="Rechercher un artiste ou une chanson"
    :keep-first="true"
    :loading="isFetching"
    @input="getAsyncData"
    @select="select"
  >
    <template slot-scope="props">
      <p><b>{{ props.option.label }}</b><span v-if="props.option.data_type == 'song' && $store.state.artists[props.option.artist_id]"> - {{ $store.state.artists[props.option.artist_id].name }}</span></p>
      <p>{{ $t(props.option.data_type) }}</p>
    </template>

    <template slot="empty">
      Aucun résulat
    </template>
  </b-autocomplete>
</template>

<script>

import debounce from "lodash/debounce";
import { toSong, toArtist } from "@/services/navigator";
import { searchFormat } from "@/services/helpers"; 

export default {
	data () {
		return {
			keyword: "",
			isFetching: false,
			data: []
		};
	},
	methods: {
		getAsyncData: debounce(function() {
			this.isFetching = true;

			this.data = [];

			let songs = Object.values(this.$store.state.songs).filter(song => {
				return searchFormat(song.label).indexOf(searchFormat(this.keyword)) >= 0;
			}).slice(0,30);

			let artists = Object.values(this.$store.state.artists).filter(artist => {
				return searchFormat(artist.name).indexOf(searchFormat(this.keyword)) >= 0;
			}).slice(0,30);


			this.data = artists.concat(songs);

			this.isFetching = false;
		}, 500),
		select (value) {
			if (value != null && value.data_type == "autority") {
				toArtist(value.id);
			}
			if (value != null && value.data_type == "song") {
				toSong(value.id);
			}
		}
	}
};
</script>
